/**
 * The device's IANA time zone as the browser reports it (e.g.
 * "Europe/London"), or null when the runtime can't say. Isolated here so the
 * Profile time-zone setting stays testable — jsdom pins this to "UTC", so
 * tests mock the module instead.
 */
export function deviceTimeZone(): string | null {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone ?? null;
  } catch {
    return null;
  }
}
